
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IFundTotal } from "@tylertech/tyler-api-types";

/**
 * FundTotalService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class FundTotalService {
    private readonly $apiService = inject(ApiService);
    
    GetFundAmountChartInfo(id: string, filterString?: string): Promise<IFundTotal[]> {
        return this.$apiService.sendAuth("IFundTotalService/GetFundAmountChartInfo", id, filterString);
    }
}
